var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiqurice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#002069"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12942_10306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5071 77C36.444 77 25 65.6494 25 51.7012C25 35.8753 37.9813 23 53.9375 23C54.7203 23 55.3609 23.6353 55.3609 24.4118C55.3609 25.1882 54.7203 25.8235 53.9375 25.8235C39.547 25.8235 27.8468 37.4282 27.8468 51.7012C27.8468 64.0965 38.0098 74.1765 50.5071 74.1765C63.0045 74.1765 73.1675 64.0965 73.1675 51.7012C73.1675 41.1976 64.5417 32.6424 53.9517 32.6424C43.3617 32.6424 34.736 41.1976 34.736 51.7012C34.736 60.3271 41.8102 67.3435 50.5071 67.3435C59.204 67.3435 66.2783 60.3271 66.2783 51.7012C66.2783 44.9529 60.7413 39.4612 53.9375 39.4612C47.1337 39.4612 41.5967 44.9529 41.5967 51.7012C41.5967 56.5718 45.5822 60.5247 50.4929 60.5247C55.4036 60.5247 59.3891 56.5718 59.3891 51.7012C59.3891 48.7224 56.9408 46.2941 53.9375 46.2941C50.9341 46.2941 48.4859 48.7224 48.4859 51.7012C48.4859 52.8024 49.3969 53.7059 50.5071 53.7059C51.6174 53.7059 52.5283 52.8165 52.5283 51.7012C52.5283 50.9247 53.1689 50.2894 53.9517 50.2894C54.7346 50.2894 55.3751 50.9247 55.3751 51.7012C55.3751 54.3553 53.1973 56.5294 50.5071 56.5294C47.8169 56.5294 45.6391 54.3694 45.6391 51.7012C45.6391 47.1553 49.3684 43.4706 53.9375 43.4706C58.5066 43.4706 62.2358 47.1694 62.2358 51.7012C62.2358 58.1247 56.9693 63.3482 50.4929 63.3482C44.0165 63.3482 38.7499 58.1247 38.7499 51.7012C38.7499 43.4 45.568 36.6376 53.9375 36.6376C62.307 36.6376 69.125 43.4 69.125 51.7012C69.125 61.88 60.7697 70.1671 50.5071 70.1671C40.2445 70.1671 31.8892 61.88 31.8892 51.7012C31.8892 39.6306 41.7817 29.8188 53.9517 29.8188C66.1217 29.8188 76.0142 39.6306 76.0142 51.7012C76.0142 65.6494 64.5702 77 50.5071 77Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12942_10306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 54,
    fill: "white",
    transform: "translate(25 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiqurice);
export default __webpack_public_path__ + "static/media/liqurice.7efbe4c74667a70fdf2ff3633792e985.svg";
export { ForwardRef as ReactComponent };